import { RANDOM_URL } from '@/defs/misc'

export const fetchRandom = async () => {
  try {
    const response = await fetch(RANDOM_URL, { cache: 'no-store', method: 'HEAD' })
    if (!response.redirected) return false

    return new URL(response.url).pathname
  } catch {
    return false
  }
}
